import { render, staticRenderFns } from "./ChannelNoteList.vue?vue&type=template&id=dbcd7ea4&scoped=true"
import script from "./ChannelNoteList.vue?vue&type=script&lang=js"
export * from "./ChannelNoteList.vue?vue&type=script&lang=js"
import style0 from "./ChannelNoteList.vue?vue&type=style&index=0&id=dbcd7ea4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbcd7ea4",
  null
  
)

export default component.exports